import { createFileRoute } from '@tanstack/react-router';

import { ChornaPageContent } from '~/components/products/chorna/ChornaPageContent';
import { DEFAULT_LOCALE } from '~/utils/i18n';

const ChornaPage = () => {
  return <ChornaPageContent />;
};

export const Route = createFileRoute('/products/chorna')({
  beforeLoad: ({ context }) => ({
    ...context,
    locale: DEFAULT_LOCALE,
  }),
  component: ChornaPage,
});

